var b = (v, y, e) => new Promise((u, s) => {
  var c = (o) => {
    try {
      m(e.next(o));
    } catch (l) {
      s(l);
    }
  }, w = (o) => {
    try {
      m(e.throw(o));
    } catch (l) {
      s(l);
    }
  }, m = (o) => o.done ? u(o.value) : Promise.resolve(o.value).then(c, w);
  m((e = e.apply(v, y)).next());
});
import "../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getOssUrl as T, getDict as k } from "@oppein/op-utils";
import { REQUIRED_CYCLE_CATEGORIES as M, getDateDisabledFunction as B, validateDeliveryDate as R } from "../utils.js";
import { DEFAULT_IMAGE as S } from "../../../constants/index.js";
import U from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/image/src/Image.js";
import { defineComponent as A, computed as d, useTemplateRef as P, onMounted as j, openBlock as g, createElementBlock as h, createElementVNode as i, createVNode as p, withCtx as C, createTextVNode as _, createCommentVNode as F } from "../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as G, unref as n } from "../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { toDisplayString as f, normalizeClass as O } from "../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import Q from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tag/src/Tag.js";
import Y from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/date-picker/src/DatePicker.js";
import q from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
const H = { class: "tw:flex tw:items-center" }, J = { class: "tw:mr-2 tw:shrink-0 tw:w-18 tw:h-18 tw:relative tw:rounded tw:overflow-hidden" }, K = { class: "tw:absolute tw:bottom-0 tw:left-0 tw:z-10 tw:text-[10px]" }, W = { class: "tw:flex tw:flex-col tw:gap-1.5 tw:w-[200px]" }, X = { class: "tw:text-sm tw:font-medium tw:text-gray-800 tw:truncate" }, Z = { class: "tw:text-xs tw:text-gray-400" }, $ = { class: "tw:w-[150px]" }, ee = {
  key: 0,
  class: "tw:mt-1 tw:text-xs tw:text-red-500 tw:font-medium"
}, we = /* @__PURE__ */ A({
  __name: "orderCycleItem",
  props: {
    item: {},
    pageMode: {},
    disabledViewDetails: { type: Boolean }
  },
  emits: ["view-details", "date-change"],
  setup(v, { emit: y }) {
    const e = v, u = y, s = d(() => e.pageMode === "view"), c = P("orderCycleItemContainer"), w = G([]), m = d(() => {
      var r;
      if (!e.item.productChannel)
        return "";
      const t = (r = w.value) == null ? void 0 : r.find((a) => a.value === e.item.productChannel);
      return t ? t.label : e.item.productChannel;
    }), o = () => b(this, null, function* () {
      w.value = yield k("ROOT_ProductChannel");
    });
    j(() => {
      o();
    });
    const l = d(() => {
      const t = { url: "", name: "" };
      return e.item.customizeList && e.item.customizeList.length > 0 ? e.item.customizeList[0] || t : !e.item.standardList || !e.item.standardList.length ? t : e.item.standardList[0] || t;
    }), x = d(() => {
      var a, D;
      const t = ((a = e.item.orderData) == null ? void 0 : a.productCategory) || "";
      return ((D = e.item.orderData) == null ? void 0 : D.old) === 1 ? !1 : !!(e.item.cupboardType === "customize" || M.includes(t));
    }), N = d(() => {
      var t;
      return e.item.cupboardType === "customize" && !((t = e.item.orderData) != null && t.old);
    }), I = (t) => t.customizeList && t.customizeList.length > 0 ? "定" : "标", L = d(() => {
      var a;
      const r = ((a = e.item.orderData) == null ? void 0 : a.old) === 1 ? 0 : 4;
      return B(e.item.storageDayNumber, r);
    }), z = () => {
      var a;
      const r = ((a = e.item.orderData) == null ? void 0 : a.old) === 1 ? 0 : 4;
      return !R(
        e.item.orderDeliveryDate,
        e.item.storageDayNumber,
        r
      );
    }, V = () => {
      u("view-details", e.item);
    }, E = (t) => {
      u("date-change", e.item.cupboardId, t);
    };
    return (t, r) => (g(), h("div", {
      ref_key: "orderCycleItemContainer",
      ref: c,
      class: "tw:flex tw:items-center tw:justify-between tw:py-2 tw:px-1 tw:bg-white tw:border-b tw:border-gray-200 tw:gap-4"
    }, [
      i("div", H, [
        i("div", J, [
          p(n(U), {
            src: l.value.url ? n(T)({ url: l.value.url }) : n(S),
            "object-fit": "contain",
            "preview-disabled": !0,
            class: "tw:w-full tw:h-full"
          }, null, 8, ["src"]),
          i("div", K, [
            p(n(Q), {
              type: "primary",
              bordered: !1,
              size: "small"
            }, {
              default: C(() => [
                _(f(I(t.item)), 1)
              ]),
              _: 1
            })
          ])
        ]),
        i("div", W, [
          i("div", X, f(t.item.orderData.spaceProduct), 1),
          i("div", Z, f(m.value), 1)
        ])
      ]),
      i("div", {
        class: O(["tw:flex tw:items-center tw:gap-1", { "tw:invisible": !x.value }])
      }, [
        r[0] || (r[0] = i("div", null, "工厂交货周期：", -1)),
        i("div", null, f(t.item.storageDayNumber != null ? t.item.storageDayNumber : "--") + " 天", 1)
      ], 2),
      i("div", $, [
        p(n(Y), {
          value: t.item.orderDeliveryDate,
          type: "date",
          format: "yyyy-MM-dd",
          class: "tw:w-full",
          "is-date-disabled": s.value ? () => !1 : L.value,
          to: c.value || "body",
          "onUpdate:value": E,
          disabled: t.item.disableDate || s.value
        }, null, 8, ["value", "is-date-disabled", "to", "disabled"]),
        !s.value && z() ? (g(), h("div", ee, " 不符合交期 ")) : F("", !0)
      ]),
      i("div", {
        class: O(["tw:w-20 tw:text-right", { "tw:invisible": !N.value }])
      }, [
        p(n(q), {
          disabled: t.disabledViewDetails,
          text: "",
          type: "primary",
          onClick: V
        }, {
          default: C(() => r[1] || (r[1] = [
            _(" 查看明细 ", -1)
          ])),
          _: 1,
          __: [1]
        }, 8, ["disabled"])
      ], 2)
    ], 512));
  }
});
export {
  we as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/order-cycle/components/orderCycleItem.vue.js
// module id = 1317
// module chunks = 67